import { createContext } from 'react';

export interface BeforeInstallPromptEvent extends Event {
    platforms: string[];
    userChoice: Promise<{
        outcome: 'accepted' | 'dismissed';
        platform: string;
    }>;
    prompt(): Promise<void>;
}

export type PwaInstallContextProps = {
    deferredPrompt: BeforeInstallPromptEvent;
};

const PwaInstallContext = createContext<PwaInstallContextProps>({
    deferredPrompt: null,
});

export default PwaInstallContext;
